import { style } from 'typestyle';
import styles from 'src/pages/AssortmentBuild/StyleEdit/DividedColumnDetailsSection/DividedColumnDetails.styles';

const container = style({
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1rem',
  $nest: {
    [`& .${styles.dataTextInput}`]: {
      fontSize: 'inherit',
      border: '1px solid rgba(0, 0, 0, 0.23)',
      borderRadius: '4px',
      padding: '6px 12px',
    },
  },
});

const fields = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  minWidth: 240,
});

const field = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
});

const label = style({
  fontSize: '0.85rem',
  fontWeight: 600,
});

export default {
  container,
  fields,
  field,
  label,
};
